import * as React from 'react';
import './CustomError.css';

/* Gjensidige Core 30 Imports */
import { Warn } from '@gjensidige/nci-core-icons/lib/warn';

export interface IProps {
  errorText: string;
}

// This component is needed to show the same type of
// error message for Checkbox components with validation since
// it doesn't support the `invalid` props
const CustomError: React.FC<IProps> = (props) => {
  return (
    <div className="error-element">
      <span className="error-icon">
        <Warn height={19} width={21} color="#E1403C" />
      </span>
      {props.errorText}
    </div>
  );
};

export default CustomError;
